/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * ISocialsBlock contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum facebookToggle {
    on = 'on',
    off = 'off'
}

export const enum instagramToggle {
    on = 'on',
    off = 'off'
}

export const enum twitterToggle {
    on = 'on',
    off = 'off'
}

export const enum alignment {
    left = 'left',
    center = 'center',
    right = 'right'
}

export interface ISocialsBlockConfig extends Msdyn365.IModuleConfig {
    facebookLink?: string;
    facebookToggle?: facebookToggle;
    facebookLogo?: Msdyn365.IImageData;
    instagramLink?: string;
    instagramToggle?: instagramToggle;
    instagramLogo?: Msdyn365.IImageData;
    twitterLink?: string;
    twitterToggle?: twitterToggle;
    twitterLogo?: Msdyn365.IImageData;
    alignment?: alignment;
}

export interface ISocialsBlockProps<T> extends Msdyn365.IModule<T> {
    config: ISocialsBlockConfig;
}
